import { Body1, Card, Title1 } from "@fluentui/react-components";
import { IOpenPanel } from "../../../../../../Interfaces/IPanel";
import { PanelDrawer } from "../../../../../../components/Panel/PanelDrawer";
import { UsePanelUbicacionSync } from "./UsePanelUbicacionSync";
import { Spinner } from "@fluentui/react";
import { IUbicacionSync } from "../../../../../../Interfaces/estadoEquipos/IEstadoEquipo";
import { useCallback } from "react";
import { PanelFooter } from "../../../../../../components/Panel/PanelFooter";

export interface IPanelUbicacionSync extends IOpenPanel{
 nivel:number;
}
export const PanelUbicacionSync =(props:IPanelUbicacionSync)=>{
    const usePanel = UsePanelUbicacionSync(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            {usePanel.ubicacioneSync.length!=0 && (
            <PanelFooter
              texto="Guardar"
              texto2={"Salir"}
              //disableButton={disableForm}
              onClick={usePanel.SyncronizarUbicaciones}
              onDismiss={usePanel.reset}
            />)}
          </>
        ),
        [usePanel.ubicacioneSync]
      );
   return (
    <PanelDrawer isOpen={props.isOpen} onDismiss={usePanel.reset} textHeader={"Ubicaciones Encontradas a Sincronizar"} 
    status={usePanel.status} mensaje={usePanel.mensaje} loading={usePanel.loading} onRenderFooter={onRenderFooter}>
        <br/>
        {!usePanel.loadingSync ? (<>
        {usePanel.ubicacioneSync.length==0?(<Body1>
            Por el Momento, todas las ubicaciones de nivel {props.nivel} ya han sido insertadas
        </Body1>):(
            <>
            {usePanel.ubicacioneSync.map((item:IUbicacionSync,index:number)=>(
               <Card>
               <Title1>{item.nombre}</Title1>
               {item.nivel>1 && (
                <Body1>Tajo: {item.tajo}</Body1>
               )}
               {item.nivel>2 && (
                <Body1>Region: {item.region}</Body1>
               )}
               {item.nivel>1 && !item.parentDisponible && (
                <Body1>El nivel anterior aun no se encuentra insertado</Body1>
               )}
               </Card>
            )
            )}
            </>
        )}
        </>):(<Spinner></Spinner>)}

    </PanelDrawer>
    )
}